<template>
    <div>
            <div class="seccion-titulo" style="text-align:center;">
                Entrar a la secretaría
            </div>   
            <p>
                Debe autenticarse para entrar a su espacio
            </p>

            <form action class="form" @submit.prevent="login">
                <div class="p-input-icon-left">
                    <i class="pi pi-user" />
                    <InputText type="text" v-model="identificador" placeholder="Usuario" v-bind:class="{'p-invalid': emptyIdentificador }" required />
                </div>
                <br/><br/>
                <div class="p-input-icon-left">
                    <i class="pi pi-lock-open" />
                    <Password v-model="clave" placeholder="Clave" v-bind:class="{'p-invalid': emptyClave }" required/>
                </div>
                <br/><br/>
                <div class="msg-warn" v-if="emptyFields">
                    <div class="msg-warn-title">
                        Debe rellenar todos los campos
                    </div>
                </div>
                <div class="msg-danger" v-if="errorAcceso">
                    <div class="msg-danger-title">
                        Ha introducido mal el identificador o la contraseña
                    </div>
                </div>
                <Button label="Acceder" icon="pi pi-sign-in" @click="doLogin" class="p-button-danger" />
            </form>
    </div>   
</template>



<script>

import Button from "primevue/button";
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import ServicioRest from "@/services/ServicioRest";
// import { Action } from 'vuex-class';
// import authTypes from '../store/types/authTypes.ts';

export default {
  name : "login",
  data() {
    return {
      identificador: "",
      clave: "",
      emptyFields: false,
      emptyIdentificador: false,
      emptyClave: false,
      errorAcceso: false,
    };
  },
   servicioRest: null,
  created() {
    this.servicioRest = new ServicioRest();
  },

   methods: {
      doLogin() {
         if (this.identificador === "" || this.clave === "") {
            this.emptyFields = true;
            this.emptyIdentificador = false;
            this.emptyClave = false;
             if (this.identificador === ""){
                 this.emptyIdentificador = true;
             }else{
                 this.emptyClave = true;
             }
         } else {
            this.emptyFields = false;
            this.emptyIdentificador = false;
            this.emptyClave = false;


            this.servicioRest.login(this.identificador, this.clave).then((response) => {
                if (response) {
                    this.$router.push("/");
                    this.$toast.add({ severity: "success", summary: "Bienvenido", detail: "Ha entrado en la secretaría virtual de Estudios propios", life: 3000 });
                } else {
                    this.errorAcceso = true;
                }
            });

            this.loginUser(this.identificador, this.clave);

         }
      },
      /*
    login() {
            // console.log(this.$data.data);
            this.loginUser(this.$data.data);
        },*/
    //@Action(`authModule/${authTypes.actions.LOGINUSER}`) loginUser: any,

      
   },

components: {
    Button,
    InputText,
    Password
  },

};


</script>

